const LAST_VISIT_KEY = 'fgv:last-visit-at';
export const CACHE_INACTIVITY_MS = 12 * 60 * 60 * 1000;

export const hasCacheExpired = (lastVisit: string | null, now = Date.now()) => {
    if (!lastVisit) return false;
    const lastVisitAt = Number(lastVisit);
    return Number.isFinite(lastVisitAt) && now - lastVisitAt >= CACHE_INACTIVITY_MS;
};

export const clearBrowserCachesAfterInactivity = async (now = Date.now()) => {
    let lastVisit: string | null;
    try {
        lastVisit = window.localStorage.getItem(LAST_VISIT_KEY);
        window.localStorage.setItem(LAST_VISIT_KEY, String(now));
    } catch (error) {
        console.warn('No se pudo consultar la ultima visita.', error);
        return false;
    }

    if (!hasCacheExpired(lastVisit, now) || !('caches' in window)) return false;

    try {
        const cacheNames = await window.caches.keys();
        await Promise.all(cacheNames.map(cacheName => window.caches.delete(cacheName)));
        return true;
    } catch (error) {
        console.warn('No se pudo limpiar el cache del sitio.', error);
        return false;
    }
};
